import { FC, ComponentProps } from 'react';
import { CatDropdown } from '@blocks-react/components/Dropdown';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';

type Option = {
  label: string;
  value: string;
  [key: string]: string;
};
type DropdownProps = ComponentProps<typeof CatDropdown> & {
  name: string;
  field: object;
  options: [Option];
  optionLabel?: string;
  optionValue?: string;
};
export const CustomDropdown: FC<DropdownProps> = ({
  name = '',
  field,
  options,
  optionLabel = 'label',
  optionValue = 'value',
  ...rest
}) => {
  return (
    <CatDropdown {...field} {...rest}>
      <CatList>
        {options?.map((item) => {
          return (
            <CatListItem
              value={{
                label: item?.[optionLabel],
                value: item?.[optionValue],
              }}
              key={item?.label}
            >
              {item?.label}
            </CatListItem>
          );
        })}
      </CatList>
    </CatDropdown>
  );
};
